<mat-dialog-content class="dialog" *ngIf="product">
  <div class="dialog-content">
    <div class="product-info-container">
      <div class="id-button-container">
        <p class="product-id">{{ product.id }}</p>
        <app-modal-close-button
          [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
      </div>

      <div class="product-detailed-info">
        <div class="image-container">
          <img
            [src]="product.images[0].src"
            alt="product image"
            class="product-image" />
        </div>
        <div class="info-container">
          <div class="info-part">
            <p class="brand">{{ product.brand.brandName }}</p>
            <p class="name">
              <b>
                {{ product.name }}
              </b>
            </p>
            <p *ngIf="product.title" class="description-title">
              <b>{{ product.title }}</b>
            </p>
            <div #description class="description">
              <div
                style="display: inline"
                *ngIf="!showFullContent"
                [innerHTML]="truncatedContent"></div>
              <div
                *ngIf="showFullContent"
                [innerHTML]="fullContent"
                class="full-text"></div>
              <span
                class="read-more"
                *ngIf="originalContent.length > showChar && !showFullContent"
                (click)="toggleText($event)">
                {{ 'Mehr anzeigen' }}
              </span>
            </div>
            <p
              class="ingredients"
              *ngIf="product.ingredients && showFullContent">
              <strong>Inhaltsstoffe:</strong>
              <span
                class="ingredients-content"
                [innerHTML]="product.ingredients"></span>
            </p>
            <span
              class="read-more less"
              *ngIf="showFullContent"
              (click)="toggleText($event)">
              Weniger anzeigen
            </span>
            <div class="product-spec-list">
              <img
                *ngFor="let spec of product.commonSpecs"
                class="product-tag-image"
                matTooltipPosition="above"
                matTooltipClass="info-tooltip"
                [matTooltip]="spec.name"
                [src]="spec.imageUrl"
                [alt]="spec.name" />
            </div>
          </div>
          <div class="info-part">
            <div class="additional-info">
              <p class="size">{{ product.inhalt }}</p>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap: 32px;
                  flex-wrap: wrap;
                ">
                <p class="price">€ {{ product.price | number: '1.2-2' }}</p>
                <div
                  class="flex align-center gap-18px"
                  *ngIf="selectedResident">
                  <app-profile-avatar
                    [name]="selectedResident.getName()"
                    [color]="selectedResident.color"
                    [size]="44"
                    [showIsFavourite]="isFavouriteForSelectedResident()"
                    [image]="selectedResident.image"
                    class="resident-avatar"></app-profile-avatar>
                  <app-inactive-resident-alert
                    *ngIf="selectedResident?.active === 0"
                    [resident]="selectedResident"></app-inactive-resident-alert>
                  <app-no-connext-account-id-error
                    *ngIf="
                      selectedResident | hasNoValidPaymentMethod
                    "></app-no-connext-account-id-error>
                  <p *ngIf="quantityLimitText" class="quantity-limit">
                    {{ quantityLimitText }}
                  </p>
                  <app-product-counter
                    class="counter"
                    buttonText="In die Tüte packen"
                    [canIncrease]="zeroPriceState(selectedResident).canIncrease"
                    [maxQuantity]="zeroPriceState(selectedResident).maxQuantity"
                    [counter]="getProductCount(selectedResident)"
                    [resident]="selectedResident"
                    (counterChange)="
                      onCounterChange($event)
                    "></app-product-counter>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="multiple-resident-section"
      *ngIf="!isMobile && residents.length > 0">
      <mat-accordion>
        <mat-expansion-panel style="box-shadow: none" [expanded]="true">
          <mat-expansion-panel-header class="custom-planer-header">
            <p class="more-carts-text text-trim" style="margin-left: 12px">
              Dieses Produkt auch für folgende Bewohner:innen kaufen:
            </p>
          </mat-expansion-panel-header>
          <div class="residents-list">
            <div class="resident-list-item" *ngFor="let resident of residents">
              <app-inactive-resident-alert
                *ngIf="resident?.active === 0"
                class="inactive-resident-alert"
                [resident]="resident"></app-inactive-resident-alert>
              <app-no-connext-account-id-error
                class="inactive-resident-alert"
                *ngIf="
                  resident | hasNoValidPaymentMethod
                "></app-no-connext-account-id-error>
              <app-profile-avatar
                [image]="resident.image"
                [name]="resident.getName()"
                [showIsFavourite]="isFavourite(resident.id)"
                [color]="resident.color"
                [size]="45"></app-profile-avatar>
              <div class="name-container">
                <p>{{ resident.fname }}</p>
                <p>{{ resident.lname }}</p>
              </div>
              <app-product-counter
                [canIncrease]="zeroPriceState(resident).canIncrease"
                [maxQuantity]="zeroPriceState(resident).maxQuantity"
                [counter]="getProductCount(resident)"
                [resident]="resident"
                (counterChange)="onCounterChange($event)"
                class="residents-list-counter"></app-product-counter>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div *ngIf="!product" class="loader-container">
    <mat-spinner></mat-spinner>
  </div>
</mat-dialog-content>
